import React from 'react'
import { Box } from '@mui/material'

import UserStats from '../userStats'
import NotifyMenu from '../notifyMenu'
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import SelectCashRegisterMenu from './cashRegisterItem';
import SelectPvMenu from './pvItem';
import { UserMenu, ThemeMenu } from '@arredo/reactjs-ui'
import useUser from '../../../hooks/user/useUser';

const UserMenuNavbar = () => {
  const { fullName, email, branch } = useUser();
  return (
    <Box display='flex' alignItems='center' gap={2}>
      <UserStats />
      <ThemeMenu />
      <NotifyMenu />
      <UserMenu fullName={fullName} email={email}>
        <MenuItem disabled>
          <ListItemText
            primary='Sucursal'
            secondary={branch?.name}
          />
        </MenuItem>

        <Divider variant='middle' />
        <SelectCashRegisterMenu />
        <Divider variant='middle' />
        <SelectPvMenu />
      </UserMenu>
    </Box>
  )
}


export default UserMenuNavbar